// service 统一出口
import LfRequest from '@/service/request/request'
import localCache from '@/utils/cache'

export default new LfRequest({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: parseInt(process.env.VUE_APP_TIME_OUT!),
  interceptors: {
    requestInterceptor: (config) => {
      const token = localCache.getCache('token')
      if (token) {
        config.headers!.Authorization = `Bearer ${token}`
      }

      return config
    },
    responseInterceptor: (res) => {
      return res
    },
    responseInterceptorCatch: (error) => {
      return error
    }
  }
})
